import { useEffect, useState } from "react";
import { IoKeyOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import FormClientsLicence from "../FormClientsLicence/FormClientsLicence";
import ListClientsLicence from "../ListClientsLicence/ListClientsLicence";

const ConsultaLicencasCliente = () => {
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId) {
			setRefreshKey((k) => k + 1);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<IoKeyOutline size={20} />}
					title="Licenças"
					navigate={"../cadastro-licencas"}
					description="Buscar"
					buttonLabel="Adicionar Licença"
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListClientsLicence filters={filters} refreshKey={refreshKey} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormClientsLicence licenca={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaLicencasCliente;
